import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import useTranslate from 'src/hooks/useTranslate';
import { Alert, Col, Link, Row, Spinner } from '@digitools/honest-react';
import DentalText from 'src/packages/dental/constants/DentalText';
import React from 'react';
import { DentalTabPanel, ErrorHtml, TabsDisclaimerText } from 'src/packages/dental/Dental';
import ClaimBoxes from 'src/packages/dental/components/ClaimBoxes';
import useMediaQuery from 'src/hooks/useMediaQuery';
export const ClaimsInfo = () => {
    const isTitleView = useMediaQuery('(max-width: 780px)');
    const { claimsLoading, currentMember, } = useDentalDataContext();
    const { t } = useTranslate();
    const hasError = currentMember?.claimSummaryError || currentMember?.hipaaViolation;
    const HipaaViolation = () => {
        const hipaaText = t(DentalText.hipaaViolationText).split('%%link%%');
        return (<p data-public={true}>
        {hipaaText[0]}
        <span>
          <Link target={'_blank'} href={'https://www.lincoln4benefits.com/adminWebContent/Production/Ardis_Forms/grup/BJ-03566.pdf'}>
            {t(DentalText.dentalInfoReleaseFormLinkText)}
          </Link>
        </span>
        {hipaaText[1]}
      </p>);
    };
    if (claimsLoading) {
        return <Spinner data-testid='claims-spinner'/>;
    }
    return (<div data-public={true}>
      {currentMember?.hipaaViolation && (<Alert type={'info'}>
          <HipaaViolation />
        </Alert>)}
      {currentMember?.claimSummaryError &&
            (isTitleView ? (<DentalTabPanel>
            <ErrorHtml errorType={currentMember.claimSummaryError} generalErrorMessage={`${t(DentalText.claimSummaryGeneralError)}`} notFoundErrorMessage={t(DentalText.claimSummaryNotFoundError)}/>
          </DentalTabPanel>) : (<ErrorHtml errorType={currentMember.claimSummaryError} generalErrorMessage={`${t(DentalText.claimSummaryGeneralError)}`} notFoundErrorMessage={t(DentalText.claimSummaryNotFoundError)}/>))}

      {!hasError && currentMember?.claims && currentMember.claims.length == 0 && (<Alert type={'info'}>{t(DentalText.claimsNotFoundInfo)}</Alert>)}
      {!hasError &&
            currentMember?.claims &&
            currentMember?.claims?.length > 0 &&
            (isTitleView ? (<DentalTabPanel>
            <ClaimBoxes />
          </DentalTabPanel>) : (<ClaimBoxes />))}
    </div>);
};
const Claims = () => {
    const { currentMember, subscriber } = useDentalDataContext();
    return (<div data-public={true}>
      {!!currentMember && !!subscriber && (<>
          <TabsDisclaimerText />
          {subscriber?.planOverview?.inNetworkOnlyClause && (<Row className={'pt-0 mt-0'}>
              <Col>
                <Alert className={'mb-3'} style={{ padding: '.5rem' }} type={'info'}>
                  {subscriber.planOverview.inNetworkOnlyClause}
                </Alert>
              </Col>
            </Row>)}
          <ClaimsInfo />
        </>)}
    </div>);
};
export default Claims;
